export default function FaultyVendingMachine(){
    
}